import * as React from 'react';
import { Loader } from '../Loader';
import { injectIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let LinkWidgetType = /*#__PURE__*/function (LinkWidgetType) {
  LinkWidgetType["ExternalLink"] = "ExternalLink";
  return LinkWidgetType;
}({});

// Typescript defination

;

// Icon Widget component with props and its types
const _LinkWidget = props => {
  const {
    loader,
    title,
    width,
    disabled,
    value,
    isClickable,
    onTriggerClick
  } = props;
  const onWidgetClick = value => {
    if (isClickable && onTriggerClick) {
      onTriggerClick({
        data: value
      });
    }
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-link ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [title ? /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(TranslateText, {
            id: title
          })
        }) : null, loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsx("div", {
          className: "kc-ui-link-div",
          children: value && value.length && typeof value === 'object' ? value.map((valueObj, index) => {
            return /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: `kc-ui-link-button ${isClickable && "kc-ui-cursor"}`,
              onClick: () => {
                onWidgetClick(valueObj);
                if (valueObj.type === LinkWidgetType.ExternalLink && valueObj.url) {
                  window.open(valueObj.url, '_blank');
                }
              },
              children: [/*#__PURE__*/_jsxs("div", {
                className: "kc-ui-link-icon-div",
                children: [valueObj.image && /*#__PURE__*/_jsx("img", {
                  className: `kc-ui-link-icon ${valueObj.subLabel && valueObj.subLabel !== "" ? 'kc-ui-link-sub-title-align' : ''}`,
                  src: valueObj.image
                }), /*#__PURE__*/_jsxs("p", {
                  className: "kc-ui-link-label",
                  children: [/*#__PURE__*/_jsx(TranslateText, {
                    id: valueObj.label
                  }), " ", valueObj.subLabel && valueObj.subLabel !== "" && /*#__PURE__*/_jsx("span", {
                    className: "kc-ui-link-sub-title",
                    children: /*#__PURE__*/_jsx(TranslateText, {
                      id: valueObj.subLabel
                    })
                  })]
                })]
              }), valueObj.progress ? /*#__PURE__*/_jsx("span", {
                className: "kc-ui-link-progress kc-ui-progress-color",
                style: {
                  width: `${valueObj.progressPercent}%`
                }
              }) : null]
            }, index);
          }) : null
        })]
      })
    })
  });
};
// Prop type defination for compile ime

// Default props
_LinkWidget.defaultProps = {
  loader: false,
  width: '100%',
  title: "",
  disabled: false,
  value: [],
  isClickable: false,
  onTriggerClick: () => {}
};
export const LinkWidget = injectIntl( /*#__PURE__*/React.memo(_LinkWidget));